// React
import React from "react";
import CalendarEdit from "./CalendarEdit";

const GroupCalendarEditTvShows = props => (
    <CalendarEdit {...props} calendarType="tvshows" />
);
export default GroupCalendarEditTvShows;